/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import {Package} from "types/entities/Package";
import {ArticleList} from "./ArticleList";
import {HallReservationSlot} from "./HallReservationSlot";
import {Activity} from "types/entities/Activity";
import {PackageItemPersonType} from "types/enums/PackageItemPersonType";
import {Translations} from "helpers/config";

export enum PackageItemItemType {
    PackageItem = "package_item",
    Upsell = "upsell",
    BasePrice = "base_price",
}

export interface DateRange {
    from: string;
    to: string;
}

export interface PackageItemExtra {
    whole_group: boolean;
    group: number | null;
    max_count: number;
    upsell_option: number;
    extra_heat: boolean;
    bookable_by_hour: boolean;
    custom_item: boolean;
    excludeDateRange: DateRange[] | [];
    includeDateRange: DateRange[] | [];
    includeHourRange: DateRange[] | [];
    excludeHourRange: DateRange[] | [];
    includeWeekDays: number[] | null;
    excludeWeekDays: number[] | null;
    article_group_id?: number | null;
}

export interface PackageItem {
    id: number;
    guid: string;
    package_id: number;
    article_id: number;
    position: number | null;
    name: Translations;
    description: Translations;
    description_html: Translations;
    image: string | null;
    price: number;
    original_price: number;
    discount: number;
    person_type: PackageItemPersonType | null;
    extra: PackageItemExtra;
    type: PackageItemItemType;
    minimum_persons_count: number;
    maximum_persons_count: number;
    activity_id: number;
    duration: number;
    is_active: number;
    is_visible: number;
    package?: Package | null;
    article: ArticleList;
    activity?: Activity | null;
    hallReservationSlots?: HallReservationSlot[] | null;
}
